import React, { Component } from 'react'
import { get } from 'lodash'
import VisibilitySensor from 'react-visibility-sensor'

import VideoJSPlayer from '~/components/VideoPlayer'
import { CloseIcon } from '~/assets/svg'
import './StandaloneVideoPlayer01.css'

const StandaloneVideoPlayer01View = ({ currentVideo, isPip, disablePip, hideAds, isPlaylistItem, nextVideoDataAction }) => {
  const getVideo = path => get(currentVideo, path)

  return (
    <div
      className={
        'StandaloneVideoPlayer01 site-border-color' + (isPip ? ' StandaloneVideoPlayer01--pip' : '')
      }
    >
      <div className="StandaloneVideoPlayer01__placeholder" />
        <div className="StandaloneVideoPlayer01__player">
          <button className="StandaloneVideoPlayer01__close-button" onClick={disablePip}>
            <CloseIcon />
          </button>
          <VideoJSPlayer
            video={currentVideo}
            isPlaylistItem={isPlaylistItem}
            nextVideoDataAction={nextVideoDataAction}
            videoId={getVideo('gist.id')}
            videoTag={get(window.settings, 'advertising.videoTag')}
            isFree={getVideo('gist.free')}
            hlsSrc={getVideo('streamingInfo.videoAssets.hls')}
            permalink={getVideo('gist.permalink')}
            autoplay={true}
            fileType={'hls'}
            hideAds={ hideAds }
            pricingOptions={getVideo('pricing')}
          />
        </div>
      </div>
  )
}

class StandaloneVideoPlayer01 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pipVideo: false,
      pipEnabled: true, // TODO: should come from layoutSettings
    }

    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
    this.disablePip = this.disablePip.bind(this)
  }

  handleVisibilityChange(isVisible) {
    this.setState({
      pipVideo: !isVisible,
    })
  }

  disablePip() {
    // TODO: mute and/or pause video
    this.setState({ pipEnabled: false })
  }

  render() {
    return (
      <VisibilitySensor
        partialVisibility={true}
        disabled={!this.state.pipEnabled}
        onChange={this.handleVisibilityChange}
      >
        <StandaloneVideoPlayer01View
          currentVideo={get(this.props.data, 'contentData.0')}
          isPip={this.state.pipEnabled && this.state.pipVideo}
          disablePip={this.disablePip}
          hideAds={ get(this.props.layout, 'settings.hideAds') }
          {...this.state}
          isPlaylistItem={this.props.isPlaylistItem}
          nextVideoDataAction={this.props.nextVideoDataAction}
        />
      </VisibilitySensor>
    )
  }
}

export default StandaloneVideoPlayer01
